import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useEventAccommodationsCheck } from '@shared/hooks/useEventAccommodationsCheck';
import { useRouterHelper } from '@shared/core';
import { withWindow } from '@shared/utils/withWindow';

export const usePurchaseConfirmationLink = (eventHandle: string | undefined | null, isAffiliate: boolean = false) => {
  const { isGuestRoute } = useRouterHelper();

  const [accommodationsOnRegistryConfirmationV2Experiment] = useIsFeatureEnabled('accommodationsOnRegistryConfirmationV2Experiment', {
    skip: !isGuestRoute || isAffiliate,
  });
  const { hasVisibleAccommodationsEventPage, hasVisibleTravelEventPage, hasTravelAccommodationListings } = useEventAccommodationsCheck({
    eventHandle: eventHandle || '',
  });

  return (initialSuccessUrl: string): string => {
    if (!accommodationsOnRegistryConfirmationV2Experiment) {
      return initialSuccessUrl;
    }

    const baseUrl = withWindow(g => g.location.origin, '');

    // Use URLSearchParams for proper escaping, then manually replace the pcId value
    const params = new URLSearchParams({
      pcId: 'TEMP_PLACEHOLDER',
      utm_medium: 'web',
      utm_source: 'confirmation_registry_purchase',
      utm_campaign: 'next_steps',
    });

    // Replace the placeholder with the unescaped template literal
    const queryString = params.toString().replace('pcId=TEMP_PLACEHOLDER', 'pcId=${purchaseContextId}');

    const path = hasVisibleAccommodationsEventPage
      ? `/${encodeURIComponent(eventHandle || '')}/accommodations`
      : hasVisibleTravelEventPage && hasTravelAccommodationListings
      ? `/${encodeURIComponent(eventHandle || '')}/travel`
      : `/${encodeURIComponent(eventHandle || '')}/registry/accommodations`;

    return `${baseUrl}${path}?${queryString}`;
  };
};
